import React from 'react';
import { HomeIcon, ScaleIcon, CarIcon, BriefcaseIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Services() {
  const services = [{
    icon: <HomeIcon className="w-8 h-8" data-id="element-231" />,
    title: 'Real Estate Documents',
    description: 'Loan modifications, deeds, closing documents, and other real estate transactions handled with precision.'
  }, {
    icon: <ScaleIcon className="w-8 h-8" data-id="element-232" />,
    title: 'Legal Notarizations',
    description: 'Wills, trusts, power of attorney, and affidavits notarized securely and confidentially.'
  }, {
    icon: <CarIcon className="w-8 h-8" data-id="element-233" />,
    title: 'Mobile Notary Service',
    description: 'We come to you! Convenient mobile notarization at your home, office, or local coffee shop.'
  }, {
    icon: <BriefcaseIcon className="w-8 h-8" data-id="element-234" />,
    title: 'Business Documents',
    description: 'Contracts, corporate documents, and employment verification forms processed efficiently.'
  }];
  return <section id="services" className="py-24 bg-white relative" data-id="element-235">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-236">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-237">
          <FadeIn data-id="element-238">
            <p className="text-blue-600 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-239">
              Professional Services
            </p>
            <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-6" data-id="element-240">
              Comprehensive{' '}
              <span className="text-gradient" data-id="element-241">
                Notary Services in Fresno, CA
              </span>
            </h2>
            <p className="text-lg text-slate-600" data-id="element-242">
              Fresno notary services include mobile notarization, real estate
              document signing, legal notarizations, and business document
              processing. Find licensed{' '}
              <strong className="font-medium text-slate-800" data-id="element-243">
                notary publics in Fresno
              </strong>{' '}
              offering 24/7 availability and same-day appointments.
            </p>
          </FadeIn>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-244">
          {services.map((service, index) => <FadeIn key={index} delay={index * 100} data-id="element-245">
              <div className="group h-full bg-slate-50 hover:bg-white border border-slate-100 p-8 rounded-2xl transition-all duration-300 hover:shadow-xl hover:-translate-y-2 relative overflow-hidden" data-id="element-246">
                {/* Decorative gradient blob on hover */}
                <div className="absolute -top-24 -right-24 w-48 h-48 bg-blue-100 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-247" />

                <div className="relative z-10" data-id="element-248">
                  <div className="w-16 h-16 bg-white rounded-xl shadow-sm flex items-center justify-center text-blue-600 mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-249">
                    {service.icon}
                  </div>
                  <h4 className="text-xl font-bold text-slate-900 mb-3" data-id="element-250">
                    {service.title}
                  </h4>
                  <p className="text-slate-600 leading-relaxed" data-id="element-251">
                    {service.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}